// The five candidate slugs are the canonical keys everywhere (CLAUDE.md HARD
// RULE): directory names, the `candidate` column, route params. Display names
// live only in this lookup — never used as a key.

export const CANDIDATE_SLUGS = [
  "abelardo-de-la-espriella",
  "paloma-valencia",
  "claudia-lopez",
  "sergio-fajardo",
  "ivan-cepeda",
] as const;

export type Slug = typeof CANDIDATE_SLUGS[number];

// Candidates currently shown in the app (the runoff finalists). The full slug
// set above stays canonical — corpus, types, colours and backend validation all
// reference it — but everything *rendered* (booths, badge picker, crowd signs,
// links) iterates this active subset. Re-add a slug here to bring one back.
export const ACTIVE_CANDIDATE_SLUGS: readonly Slug[] = [
  "abelardo-de-la-espriella",
  "ivan-cepeda",
];

const DISPLAY_NAMES: Record<Slug, string> = {
  "abelardo-de-la-espriella": "Abelardo de la Espriella",
  "paloma-valencia": "Paloma Valencia",
  "claudia-lopez": "Claudia López",
  "sergio-fajardo": "Sergio Fajardo",
  "ivan-cepeda": "Iván Cepeda",
};

// Primary brand colour per candidate (their own published material — see
// data/candidates.json). Used only as a subtle accent (a soft halo behind the
// portrait); the room stays black-on-white line art.
const CANDIDATE_COLORS: Record<Slug, string> = {
  "abelardo-de-la-espriella": "#B10000",
  "paloma-valencia": "#004AAD",
  "claudia-lopez": "#5B2D8E",
  "sergio-fajardo": "#005FCF",
  "ivan-cepeda": "#F3930D",
};

export function isSlug(value: string): value is Slug {
  return (CANDIDATE_SLUGS as readonly string[]).includes(value);
}

export function displayName(slug: Slug): string {
  return DISPLAY_NAMES[slug];
}

export function candidateColor(slug: Slug): string {
  return CANDIDATE_COLORS[slug];
}
